module.exports = __webpack_public_path__ + "static/media/brand35.63f25dfb.png";